import "./styles/global.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initialiseDeployment } from "./config/deployment";
import { syncColorScheme } from "./theme";

const renderConfigError = (root: HTMLElement) => {
  root.innerHTML =
    '<p style="padding:48px;text-align:center;font-family:sans-serif">PQChat Rooms is not configured correctly. Please contact your administrator.</p>';
};

const bootstrap = async () => {
  const root = document.getElementById("root");
  if (!root) {
    return;
  }

  syncColorScheme();

  try {
    await initialiseDeployment();
  } catch (error) {
    console.error("Failed to load deployment config", error);
    renderConfigError(root);
    return;
  }

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};

void bootstrap();
